<div class="flex justify-between items-center">
  <span class="body-md text-content-text-body-secondary">Schriftgröße</span>
  <core-dropdown-select class="min-w-[200px]" [formControl]="control" [options]="options" [selector]="selector"
                        [comparator]="comparator" />
</div>
<div class="w-1/2 body-xs text-content-text-body-secondary">
  Die Änderung der Schriftgröße wirkt sich ausschließlich auf den Text im Chat-Fenster aus.
</div>
